import {Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import {SessionBaseComponent} from '../../../shared/components/session.base.component';
import {TaskLogicServiceService} from '../../transport-operation/services/task-logic-service.service';
import {LaasOption} from '../../../core/models/laas-option';
import {deepCopy, isNullOrEmpty, mapToObject} from '../../../core/utils/common-functions';


@Component({
  selector: 'laas-advance-task-maintenance',
  templateUrl: './advance-task-maintenance.component.html',
  styleUrls: ['./advance-task-maintenance.component.scss']
})
export class AdvanceTaskMaintenanceComponent extends SessionBaseComponent implements OnInit {

  isVisible: boolean;
  advanceTaskCode: Map<string, string[]> = new Map();
  advanceTaskCodeFieldType: Map<string, any[]> = new Map();
  advanceValues: any = {};
  advanceTaskForFrontEnd: Map<string, any[]> = new Map();

  @Input() advanceTaskListObject: any;
  @Input() lockTypeOptions: LaasOption[];
  lockCodeOptions: LaasOption[];
  @Input() lockReasonOptions: LaasOption[];
  @Input() receivingTaskOptions: any;

  @Output() visibleChange = new EventEmitter<any>();
  @Output() updateAdvanceTask = new EventEmitter<any>();
  @Input() propTaskList: any;

  @Input() consigneeKeyOptions: LaasOption[];
  @Input() vendorNumberOptions: LaasOption[];

  invalidStatesTask: { [key: string]: { [field: string]: boolean } } = {};

  constructor(
    injector: Injector,
    private taskLogicServiceService: TaskLogicServiceService,
  ) {
    super(injector);
    this.isVisible = false;

    this.lockTypeOptions = [];
    this.lockCodeOptions = [];
    this.lockReasonOptions = [];
    this.consigneeKeyOptions = [];
    this.vendorNumberOptions = [];
  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  dialogVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
  }

  assertType(task: any) {
    return String(task);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.taskLogicServiceService.advanceTaskForFrontEnd().subscribe({
      next: result => {
        Object.entries(result).forEach(([key, value]: any) => {
          this.advanceTaskForFrontEnd.set(key, value);
        });
      }
    });
  }

  async initComponent(prop: any) {
    this.advanceTaskCodeFieldType.clear();
    this.advanceTaskCode.clear();
    let rowData =deepCopy(prop);
    for (const [key, value] of this.advanceTaskListObject) {
      if (!isNullOrEmpty(rowData) && this.checkAdvanceTaskCodeList(key, rowData?.taskCode) && !this.advanceTaskCode.has(key)) {
        this.advanceTaskCode.set(key, value);
      }
    }


    for (const [key, value] of this.advanceTaskForFrontEnd) {
      if (!isNullOrEmpty(rowData) && this.checkAdvanceTaskCodeList(key, rowData?.taskCode) && !this.advanceTaskCodeFieldType.has(key)) {
        this.advanceTaskCodeFieldType.set(key, value);
      }
    }

    this.initNgModel();

    this.updateAdvanceTaskInit(prop);

  }

  async reLoadInit() {
    await this.initComponent(this.propTaskList);
  };

  async updateAdvanceTaskClick() {
    if (this.checkInvalidStatesTask(this.advanceValues)){
      return;
    }

    let taskAdvanceValue: any = deepCopy(this.advanceValues);
    this.updateAdvanceTask.emit(taskAdvanceValue);
    this.initNgModel();
  }

  checkFieldType(fieldType: any, field: string) {
    return fieldType == field;
  }

  checkAdvanceTaskCodeList(taskCode: string, propTaskCode: string[]) {
    return propTaskCode?.some((prop) => prop == taskCode);
  }

  initNgModel() {
    this.advanceValues = {};
    this.advanceTaskCode.forEach((field, task) => {
      const valueObject: any = {};

      field.forEach(property => {
        valueObject[property] = null;
      });
      this.advanceValues[task] = valueObject;
    });
  }

  checkOptionsList(fieldName: any): any[] {
    switch (fieldName) {
      case 'lockType':
        return this.lockTypeOptions;
      case 'lockCode':
        return this.lockCodeOptions;
      case 'lockReason':
        return this.lockReasonOptions;
      default:
        return [];
    }
  }

  checkOptionsListSize(fieldName: any): boolean {
    switch (fieldName) {
      case 'lockCode':
        return true;
      default:
        return false;
    }
  }

  private updateAdvanceTaskInit(prop: any) {
    if (prop.advanceTaskRemark.size === 0) return;

    prop.advanceTaskRemark.forEach((value:any, key:any) => {
      if (this.advanceValues.hasOwnProperty(key)) {
        this.advanceValues[key] = { ...value };

        // 如果有帶入預設的 lockType，手動觸發連動邏輯以初始化 lockCode 選項
        if (this.advanceValues[key]['lockType']) {
          this.initOption(this.advanceValues[key]['lockType']);
        }
      }
    });
  }

  initOption(fieldName: any):void {
    switch (fieldName) {
      case 'Customer':
        this.lockCodeOptions = this.consigneeKeyOptions;
        break;
      case 'Vendor':
        this.lockCodeOptions = this.vendorNumberOptions;
        break;
      default:
        this.lockCodeOptions=[];
    }
  }

  checkInvalidStatesTask(advanceValues: Record<string, Record<string, any>>): boolean {
    const validStatesTask = ['N03-5', 'N03-7'];

    this.invalidStatesTask = validStatesTask.reduce((acc, key) => {
      if (key in advanceValues) {
        const fieldInvalid = Object.entries(advanceValues[key]).reduce((fieldAcc, [field, value]) => {
          if (field === 'otherReasonDesc') {
            if (advanceValues[key]['lockReason'] === '7' && isNullOrEmpty(value)) {
              fieldAcc[field] = true;
            }
          } else if (isNullOrEmpty(value)) {
            fieldAcc[field] = true;
          }
          return fieldAcc;
        }, {} as Record<string, boolean>);

        if (Object.keys(fieldInvalid).length > 0) {
          acc[key] = fieldInvalid;
        }
      }
      return acc;
    }, {} as Record<string, Record<string, boolean>>);

    return Object.keys(this.invalidStatesTask).length > 0;
  }

  checkInvalidStates(task: string, field: any) {
    return this.invalidStatesTask[task]?.[field];
  }
}
